import { MARKET_FILTERS } from '@/constants/market';
import { IMarketPair } from '@/features/market/types';
import { ALL_SELECTOR } from '@/types/global';
import { IMarginSearchProps } from '@/types/search';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface MarketPairInfoState {
  chainMarketPairInfos: { [chainId: number]: { [pairId: string]: IMarketPair } };
  setMarketPairInfo: (chainId: number, info: IMarketPair) => void;
  marginSearchProps: IMarginSearchProps;
  setMarginSearchProps: (marginSearchProps: Partial<IMarginSearchProps>) => void;
}

export const useMarketPairInfoStore = create<MarketPairInfoState>()(
  devtools(
    persist(
      (set) => ({
        chainMarketPairInfos: {},
        setMarketPairInfo: (chainId, info) =>
          set((state) => ({
            chainMarketPairInfos: {
              ...state.chainMarketPairInfos,
              [chainId]: {
                ...state.chainMarketPairInfos?.[chainId],
                [`${info.instrumentAddr}-${info.expiry}`]: info,
              },
            },
          })),
        marginSearchProps: {
          marginSelector: ALL_SELECTOR.ALL,
          filter: MARKET_FILTERS.PERPETUAL,
          marginCustomSelectorId: null,
          search: '',
          selectedChainIds: [],
        },
        setMarginSearchProps: (marginSearchProps) =>
          set((state) => ({ marginSearchProps: { ...state.marginSearchProps, ...marginSearchProps } })),
      }),
      {
        name: 'market-pair-info-store',
        partialize: (state) => ({ marginSearchProps: state.marginSearchProps }),
      },
    ),
  ),
);
